var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_633_217313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48779 13.1221C9.40381 13.1221 9.33936 13.0947 9.29443 13.04C9.24951 12.9854 9.22705 12.9121 9.22705 12.8203V11.9678H9.08936C8.79834 11.9678 8.55322 11.916 8.354 11.8125C8.15479 11.709 8.00342 11.5576 7.8999 11.3584C7.79834 11.1592 7.74756 10.916 7.74756 10.6289V8.38477C7.74756 8.09766 7.79834 7.85449 7.8999 7.65527C8.00342 7.45605 8.15479 7.30469 8.354 7.20117C8.55322 7.0957 8.79834 7.04297 9.08936 7.04297H12.8628C13.1538 7.04297 13.3989 7.0957 13.5981 7.20117C13.7974 7.30469 13.9478 7.45605 14.0493 7.65527C14.1528 7.85449 14.2046 8.09766 14.2046 8.38477V10.6289C14.2046 10.916 14.1528 11.1592 14.0493 11.3584C13.9478 11.5576 13.7974 11.709 13.5981 11.8125C13.3989 11.916 13.1538 11.9678 12.8628 11.9678H10.8823L9.82471 12.9346C9.75439 12.999 9.69482 13.0459 9.646 13.0752C9.59912 13.1064 9.54639 13.1221 9.48779 13.1221ZM10.4897 11.0771H11.6265C11.6851 11.0771 11.7339 11.0586 11.7729 11.0215C11.812 10.9844 11.8315 10.9365 11.8315 10.8779C11.8315 10.8232 11.812 10.7764 11.7729 10.7373C11.7339 10.6982 11.6851 10.6787 11.6265 10.6787H11.2808V9.26074C11.2808 9.18457 11.2622 9.12305 11.2251 9.07617C11.188 9.0293 11.1333 9.00586 11.061 9.00586H10.5366C10.48 9.00586 10.4312 9.02539 10.3901 9.06445C10.3511 9.10352 10.3315 9.15039 10.3315 9.20508C10.3315 9.26172 10.3511 9.30859 10.3901 9.3457C10.4312 9.38281 10.48 9.40137 10.5366 9.40137H10.8354V10.6787H10.4897C10.4312 10.6787 10.3823 10.6982 10.3433 10.7373C10.3042 10.7764 10.2847 10.8232 10.2847 10.8779C10.2847 10.9365 10.3042 10.9844 10.3433 11.0215C10.3823 11.0586 10.4312 11.0771 10.4897 11.0771ZM10.9526 8.54297C11.0562 8.54297 11.1421 8.50781 11.2104 8.4375C11.2808 8.36523 11.3159 8.27832 11.3159 8.17676C11.3159 8.07324 11.2808 7.98633 11.2104 7.91602C11.1421 7.84375 11.0562 7.80762 10.9526 7.80762C10.8511 7.80762 10.7642 7.84375 10.6919 7.91602C10.6216 7.98633 10.5864 8.07324 10.5864 8.17676C10.5864 8.27832 10.6216 8.36523 10.6919 8.4375C10.7642 8.50781 10.8511 8.54297 10.9526 8.54297Z",
    fill: "#FFC445"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_633_217313",
    x: 0.747559,
    y: 0.0429688,
    width: 20.457,
    height: 20.0791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.770518 0 0 0 0 0.272217 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_633_217313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_633_217313",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.c46359cceb0151b7924e5ad1a7586e1a.svg";
export { ForwardRef as ReactComponent };